import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";

const styles = createStyles({
    item: {
        padding: "0 8px !important",
    },
    container: {
        margin: "0 -8px !important",
        width: "unset",
    },
});

export const useGridSharedStyles = makeStyles(styles);
